/**
 * H2H tab: summary (stat discs + ratio bar), meeting list, optional “Season so far”
 * when `h2h.seasonSoFar` is present (see mocks). Section cards have no heading.
 */

import React from 'react';
import { View } from 'react-native';
import { SectionCard } from '../SectionCard';
import type { MatchHubMockData } from '../../../src/match/types/matchHub.types';
import { MatchHubH2HSummaryHeader } from './MatchHubH2HSummaryHeader';
import { MatchHubH2HMeetingRow } from './MatchHubH2HMeetingRow';
import { MatchHubH2HSeasonSoFarCard } from './MatchHubH2HSeasonSoFarCard';

export interface MatchHubH2HPanelProps {
  data: MatchHubMockData;
}

export const MatchHubH2HPanel: React.FC<MatchHubH2HPanelProps> = ({ data }) => {
  const { h2h, home, away, matchInfo } = data;

  return (
    <View testID="match-hub-h2h">
      <SectionCard title="Head to Head">
        <MatchHubH2HSummaryHeader
          homeWins={h2h.homeWins}
          draws={h2h.draws}
          awayWins={h2h.awayWins}
          goalsHome={h2h.goalsHome}
          goalsAway={h2h.goalsAway}
          home={home}
          away={away}
        />
      </SectionCard>

      <SectionCard title="Previous Meetings">
        {h2h.meetings.map((m, index) => (
          <MatchHubH2HMeetingRow
            key={`${m.date}-${m.homeTeam}-${m.awayTeam}`}
            meeting={m}
            isLast={index === h2h.meetings.length - 1}
          />
        ))}
      </SectionCard>

      {h2h.seasonSoFar !== undefined ? (
        <MatchHubH2HSeasonSoFarCard
          snapshot={h2h.seasonSoFar}
          home={home}
          away={away}
          leagueCountryCode={matchInfo.countryCode}
        />
      ) : null}
    </View>
  );
};
